/**
 * Product SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

const ProductSEO = ({ product, description }) => {
  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          wcSettings {
            currency
          }
        }
      }
    `
  );

  return (
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        name: product?.name,
        image: product?.image?.sourceUrl,
        description: description,
        sku: product.sku ?? "",
        brand: {
          "@type": "Brand",
          name:
            product.productBrands.nodes.length > 0
              ? product.productBrands.nodes[0].name
              : "",
        },
        offers: {
          "@type": "Offer",
          url: process.env.GATSBY_SITE_URL + product.uri,
          priceCurrency: wp?.wcSettings?.currency,
          price: product?.priceRaw
            ? product?.priceRaw
            : product?.price?.replace("kr", ""),
          availability:
            product?.stockStatus === "IN_STOCK" ? "InStock" : "OutOfStock",
        },
        hasEnergyConsumptionDetails: {
          "@type": "EnergyConsumptionDetails",
          hasEnergyEfficiencyCategory:
            product?.crbProductSpecifications?.length > 0 &&
            product?.crbProductSpecifications?.find(
              (item) => item.title === "Energiklasse"
            )?.text,
        },
      })}
    </script>
  );
};

ProductSEO.defaultProps = {
  lang: `no`,
};

ProductSEO.propTypes = {
  product: PropTypes.object,
  lang: PropTypes.string,
  description: PropTypes.string,
};

export default ProductSEO;
